module.exports = __webpack_public_path__ + "img/ds6.bd72dfd6.png";